TitleInterceptor = ($rootScope) ->
  $rootScope.$on "$routeChangeSuccess", (event, current, previous) ->
    return unless current.$$route
    $rootScope.title = current.$$route.title

TitleInterceptor.$inject = [
  '$rootScope'
]

module.exports = TitleInterceptor



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/title/title-interceptor.coffee